<template>
  <div>
    <div v-if="payrollData && payrollData.employees">
      <v-data-table
        :headers="headers"
        :items="payrollData.employees"
        show-select
        class="elevation-1"
        v-model="selectedItems"
        @input="getSelectedItems"
      >
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payrollData: {
      default: null,
    },
  },

  data: () => ({
    selectedItems: [],
    headers: [
      { value: "id" },
      { text: "Full Names", value: "name" },
      { text: "ID Number", value: "id_number" },
      { text: "Pay Date", value: "payroll_date" },
      { text: "Base Salary", value: "base_salary" },
      { text: "Rate Hours", value: "total_hours" },
      { text: "Total Rates", value: "total_rates" },
      { text: "Paye", value: "paye" },
      { text: "Gross Earnings", value: "gross_earnings" },
      { text: "Gross Deductions", value: "gross_deductions" },
      { text: "Net", value: "net_salary" },
    ],
  }),
  methods: {
    getSelectedItems() {
      this.$emit("selected-staff-from-payroll", this.selectedItems);
      //console.log('som')
    },
  },
};
</script>
